// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options-selected {
  border-radius: 50px;
  height: 22px;
  width: 22px;
  color: white;
  margin-right: 5px;
  margin-left: -8px;
  font-size: 14px;
  font-weight: 500;
  font-family: "Poppins";
  padding-bottom: 22px;
}

.filter-conatiner-with-tabs.MuiButtonBase-root {
  border-radius: 6px;
  border: 1px solid var(--Neutral-4, #f0f0f0);
  background: var(--Neutral-1, #fff);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  color: var(--Text-Highest, rgba(1, 1, 2, 0.92));
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.05px;
  width: fit-content;
  padding: 16px;
  text-transform: none;
}

.filter-conatiner-with-tabs.MuiButtonBase-root:hover {
  background-color: white;
}

.filter-conatiner.MuiButtonBase-root {
  height: 40px;
  border-radius: 44px;
  padding: 16px;
  border: 1px solid rgba(1, 1, 2, 0.72);
  color: rgba(1, 1, 2, 0.72);
  font-size: 14px;
  font-weight: 500;
  font-family: poppins;
  text-transform: none;
  width: fit-content;
}

.filter-conatiner.MuiButtonBase-root:hover {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/filters/filters.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,+CAA+C;EAC/C,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".options-selected {\n  border-radius: 50px;\n  height: 22px;\n  width: 22px;\n  color: white;\n  margin-right: 5px;\n  margin-left: -8px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"Poppins\";\n  padding-bottom: 22px;\n}\n\n.filter-conatiner-with-tabs.MuiButtonBase-root {\n  border-radius: 6px;\n  border: 1px solid var(--Neutral-4, #f0f0f0);\n  background: var(--Neutral-1, #fff);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  color: var(--Text-Highest, rgba(1, 1, 2, 0.92));\n  text-align: center;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n  width: fit-content;\n  padding: 16px;\n  text-transform: none;\n}\n\n.filter-conatiner-with-tabs.MuiButtonBase-root:hover {\n  background-color: white;\n}\n\n.filter-conatiner.MuiButtonBase-root {\n  height: 40px;\n  border-radius: 44px;\n  padding: 16px;\n  border: 1px solid rgba(1, 1, 2, 0.72);\n  color: rgba(1, 1, 2, 0.72);\n  font-size: 14px;\n  font-weight: 500;\n  font-family: poppins;\n  text-transform: none;\n  width: fit-content;\n}\n\n.filter-conatiner.MuiButtonBase-root:hover {\n  background-color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
